import { AnimatePresence } from 'framer-motion';
import { createBrowserHistory } from 'history';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, Router, Switch, useLocation } from 'react-router-dom';
import { MotionModal } from '../components/motion-modal/motion-modal';
import { routes } from '../config';
import { store } from '../store';
import { DetailsModal } from '../views/ats-details/details-modal/details-modal';
import { DetailsPage } from '../views/ats-details/details-page/details-page';
import Search from '../views/globalsearch';
import { AuthRoutes } from './auth-routes/auth-routes';
import { DetailsRouter } from './details-router';
import { HomePage } from './homepage';
import { ManagedRoutes } from './managed-routes';
import { UnmanagedRoutes } from './unmanaged-routes/unmanaged-routes';
import { UtilityRoutes } from './utility-routes';
import LinkTvBox from '../views/linktvbox';
import { ErrorBoundary } from '../components/error-boundary';
import { CastDetector } from '../chromecast/cast-detector/cast-detector';
import { EventRouter } from './event-router';
import { ScriptService } from '../controllers/ScriptService';

export const history = createBrowserHistory();

export const details = new DetailsRouter(history, store);
export const eventRouter = new EventRouter(history);

export const inDevEnvironment =
  window.location.href.indexOf('tvbeta') !== -1 ||
  window.location.href.indexOf('atvweb-st3') !== -1 ||
  window.location.href.indexOf('atvweb-int3') !== -1 ||
  window.location.href.indexOf('localhost') !== -1;

function Routes() {
  return (
    <Router history={history}>
      <ErrorBoundary>
        <CastDetector />
      </ErrorBoundary>

      <RoutesSwitch />
    </Router>
  );
}

function RoutesSwitch() {
  const location = useLocation();
  const background = useSelector((state) => state.router.background);

  return (
    <Fragment>
      <Switch location={background || location}>
        <Route path="/details/:type/:subType?/:id">
          <DetailsPage />
        </Route>

        <Route path={routes.authentication.base}>
          <AuthRoutes />
        </Route>

        <Route path="/" exact>
          <HomePage />
        </Route>

        {inDevEnvironment && (
          <Route path={'/tool'}>
            <UtilityRoutes />
          </Route>
        )}

        <Route path={'/link'}>
          <LinkTvBox />
        </Route>

        <Route
          path={routes.ios.base}
          render={() => {
            return (
              <div className="light">
                <a href="https://itunes.apple.com/no/app/altibox/id1164396975?mt=8">Last ned appen her</a>
              </div>
            );
          }}
        />

        <Route path={routes.search.base + '*'}>
          <Search />
        </Route>

        <Route path={routes.unmanaged.base}>
          <UnmanagedRoutes />
        </Route>

        <Route path="/:slug">
          <ManagedRoutes />
        </Route>
      </Switch>

      <AnimatePresence initial={false} exitBeforeEnter>
        {background && (
          <MotionModal
            key={background.pathname}
            isOpen={true}
            withPresence={false}
            onRequestClose={() => details.close()}
            selector={details.isPlayer(background) ? document.querySelector('.player-fullscreen-wrapper') : undefined}
            // The top navbar has a height of 60px. The modal looked a bit weird when it was all the way at the top in fullscreen.
            offsetTop={details.isPlayer(background) && ScriptService.isFullscreen() ? 32 + 60 : 32}
          >
            <Route path="/details/:type/:subType?/:id">
              <DetailsModal />
            </Route>
          </MotionModal>
        )}
      </AnimatePresence>
    </Fragment>
  );
}

export default Routes;
